/// <reference types="./disclosure.d.mts" />
import * as $json from "../../../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../../../gleam_stdlib/gleam/result.mjs";
import * as $lustre from "../../../../../lustre/lustre.mjs";
import * as $a from "../../../../../lustre/lustre/attribute.mjs";
import * as $effect from "../../../../../lustre/lustre/effect.mjs";
import * as $element from "../../../../../lustre/lustre/element.mjs";
import * as $e from "../../../../../lustre/lustre/event.mjs";
import * as $sketch from "../../../../../sketch/sketch.mjs";
import * as $sl from "../../../../../sketch_lustre/sketch/lustre.mjs";
import * as $attributes from "../../../../ds/internals/components/attributes.mjs";
import * as $s from "../../../../ds/internals/components/disclosure/styles.mjs";
import * as $events from "../../../../ds/internals/components/events.mjs";
import * as $properties from "../../../../ds/internals/components/properties.mjs";
import { toList, CustomType as $CustomType } from "../../../../gleam.mjs";

class Heading extends $CustomType {
  constructor(attributes, children) {
    super();
    this.attributes = attributes;
    this.children = children;
  }
}

class Panel extends $CustomType {
  constructor(attributes, children) {
    super();
    this.attributes = attributes;
    this.children = children;
  }
}

export class Model extends $CustomType {
  constructor(children, default_expanded, disabled, expanded, name) {
    super();
    this.children = children;
    this.default_expanded = default_expanded;
    this.disabled = disabled;
    this.expanded = expanded;
    this.name = name;
  }
}

export class ChildrenEmittedMsg extends $CustomType {
  constructor(msg) {
    super();
    this.msg = msg;
  }
}

export class UserChangedChildren extends $CustomType {
  constructor(children) {
    super();
    this.children = children;
  }
}

export class UserChangedDisabled extends $CustomType {
  constructor(disabled) {
    super();
    this.disabled = disabled;
  }
}

export class UserChangedExpanded extends $CustomType {
  constructor(expanded) {
    super();
    this.expanded = expanded;
  }
}

export class UserChangedName extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}

export class UserClickedExpand extends $CustomType {}

export function heading(attributes, children) {
  return new Heading(attributes, children);
}

export function panel(attributes, children) {
  return new Panel(attributes, children);
}

function init(_) {
  let children = [
    new Heading(toList([]), toList([])),
    new Panel(toList([]), toList([])),
  ];
  let _pipe = new Model(children, false, false, false, new $option.None());
  return $pair.new$(_pipe, $effect.none());
}

function is_heading(item) {
  if (item instanceof Heading) {
    return true;
  } else {
    return false;
  }
}

function is_panel(item) {
  if (item instanceof Heading) {
    return false;
  } else {
    return true;
  }
}

function update_children(model, children) {
  let _block;
  let _record = model;
  _block = new Model(
    [
      (() => {
        let _pipe = $list.find(children, is_heading);
        return $result.unwrap(_pipe, new Heading(toList([]), toList([])));
      })(),
      (() => {
        let _pipe = $list.find(children, is_panel);
        return $result.unwrap(_pipe, new Panel(toList([]), toList([])));
      })(),
    ],
    _record.default_expanded,
    _record.disabled,
    _record.expanded,
    _record.name,
  );
  let _pipe = _block;
  return $pair.new$(_pipe, $effect.none());
}

function update_disabled(model, disabled) {
  let _block;
  let _record = model;
  _block = new Model(
    _record.children,
    _record.default_expanded,
    disabled,
    _record.expanded,
    _record.name,
  );
  let model$1 = _block;
  return [model$1, $effect.none()];
}

function update_expanded(model, expanded) {
  let _block;
  let _record = model;
  _block = new Model(
    _record.children,
    _record.default_expanded,
    _record.disabled,
    expanded,
    _record.name,
  );
  let model$1 = _block;
  return [model$1, $effect.none()];
}

function update_name(model, name) {
  let name$1 = new $option.Some(name);
  let _block;
  let _record = model;
  _block = new Model(
    _record.children,
    _record.default_expanded,
    _record.disabled,
    _record.expanded,
    name$1,
  );
  let model$1 = _block;
  return [model$1, $effect.none()];
}

function user_clicked_expand(model) {
  let expanded = !model.expanded;
  let _block;
  let _record = model;
  _block = new Model(
    _record.children,
    _record.default_expanded,
    _record.disabled,
    expanded,
    _record.name,
  );
  let model$1 = _block;
  return [
    model$1,
    $e.emit(
      "expanded",
      (() => {
        let name = $json.nullable(model$1.name, $json.string);
        let expanded$1 = $json.bool(expanded);
        return $json.object(toList([["name", name], ["expanded", expanded$1]]));
      })(),
    ),
  ];
}

function update(model, msg) {
  if (msg instanceof ChildrenEmittedMsg) {
    let msg$1 = msg.msg;
    return [model, $events.traverse(msg$1)];
  } else if (msg instanceof UserChangedChildren) {
    let children = msg.children;
    return update_children(model, children);
  } else if (msg instanceof UserChangedDisabled) {
    let disabled = msg.disabled;
    return update_disabled(model, disabled);
  } else if (msg instanceof UserChangedExpanded) {
    let expanded = msg.expanded;
    return update_expanded(model, expanded);
  } else if (msg instanceof UserChangedName) {
    let name = msg.name;
    return update_name(model, name);
  } else {
    return user_clicked_expand(model);
  }
}

function on_expand(model) {
  let $ = model.disabled;
  if ($) {
    return $a.none();
  } else {
    return $e.on_click(new UserClickedExpand());
  }
}

function display_panel(model) {
  return $bool.lazy_guard(
    !model.expanded,
    $element.none,
    () => {
      let $ = model.children;
      let panel$1 = $[1];
      return $s.panel_wrapper(
        toList([]),
        toList([
          (() => {
            let _pipe = $s.panel(panel$1.attributes, panel$1.children);
            return $element.map(
              _pipe,
              (var0) => { return new ChildrenEmittedMsg(var0); },
            );
          })(),
        ]),
      );
    },
  );
}

function view(model, stylesheet) {
  return $sl.render(
    stylesheet,
    toList([$sl.node()]),
    () => {
      let $ = model.children;
      let heading$1 = $[0];
      let expanded = $attributes.bool_to_string(model.expanded);
      let disabled = $attributes.bool_to_string(model.disabled);
      let expanded$1 = $a.data("expanded", expanded);
      let disabled$1 = $a.data("disabled", disabled);
      return $s.disclosure(
        toList([]),
        toList([
          $s.heading_wrapper(
            toList([on_expand(model), expanded$1, disabled$1]),
            toList([
              (() => {
                let _pipe = $s.heading(heading$1.attributes, heading$1.children);
                return $element.map(
                  _pipe,
                  (var0) => { return new ChildrenEmittedMsg(var0); },
                );
              })(),
              (() => {
                let $1 = model.expanded;
                if ($1) {
                  return $s.light_separator();
                } else {
                  return $element.none();
                }
              })(),
            ]),
          ),
          display_panel(model),
        ]),
      );
    },
  );
}

export const tag = "freyja-disclosure";

export function register(stylesheet) {
  let view$1 = (_capture) => { return view(_capture, stylesheet); };
  let _pipe = $lustre.component(
    init,
    update,
    view$1,
    toList([
      $attributes.bool(
        "disabled",
        (var0) => { return new UserChangedDisabled(var0); },
      ),
      $attributes.bool(
        "expanded",
        (var0) => { return new UserChangedExpanded(var0); },
      ),
      $attributes.string(
        "name",
        (var0) => { return new UserChangedName(var0); },
      ),
      $properties.coerce(
        "children-nodes",
        (var0) => { return new UserChangedChildren(var0); },
      ),
    ]),
  );
  return $lustre.register(_pipe, tag);
}
